import React from 'react';
import BasketItemsPerformance from './components/BasketItemsPerformance';
import BasketOrdersSection from './components/BasketOrdersSection';
import BasketItemDetails from './components/BasketItemDetails';

// =============================================================================
// BasketItemsTab (V2) — two-pane workspace layout.
//
// Top:    Performance card (full width)              ┐
//         KPIs + range selector + chart              │ Macro stats
//                                                    ┘
// Below:  Orders browser | Basket Items (25% / 75%)  ┐
//         (sidebar)      | (main table + donut)     │ Master-detail view
//                                                    ┘
//
// Preserves the original intent from develop — orders rail next to stats —
// while replacing the AntD Grid `push=6 / order` hack with a cleaner flex
// split via the `.campaign-overview__basket-split` SCSS block.
// =============================================================================

const BasketItemsTab = ({
  campaignOrder,
  pageSize,
  basketItemsData,
  basketItemsGroupedOrderId,
  basketItemsGroupedTotalCount,
  currentPage,
  basketItemsDataLoading,
  basketItemsByDate,
  detailBarSummary,
  onDateChange,
  onPageChange,
  expandedRowKeys,
  onExpand,
  searchTerm,
  onSearchChange,
  onSearch,
  basketItemsSearchTerms,
  onBasketItemsSearchChange,
  loading,
  dateRange,
}) => {
  return (
    <>
      <BasketItemsPerformance
        detailBarSummary={detailBarSummary}
        byDate={basketItemsByDate}
        dateRange={dateRange}
        onDateChange={onDateChange}
        campaignOrder={campaignOrder}
        loading={loading}
      />

      <div className="campaign-overview__basket-split">
        <div className="campaign-overview__basket-split-aside">
          <BasketOrdersSection
            orders={basketItemsGroupedOrderId || []}
            total={basketItemsGroupedTotalCount || 0}
            currentPage={currentPage}
            pageSize={pageSize}
            loading={basketItemsDataLoading}
            onPageChange={onPageChange}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            onSearch={onSearch}
            expandedRowKeys={expandedRowKeys}
            onExpand={onExpand}
          />
        </div>

        <div className="campaign-overview__basket-split-main">
          <BasketItemDetails
            basketItems={basketItemsData || []}
            searchTerms={basketItemsSearchTerms}
            onSearchChange={onBasketItemsSearchChange}
          />
        </div>
      </div>
    </>
  );
};

export default BasketItemsTab;
